import { jsx as a, jsxs as C } from "react/jsx-runtime";
import i, { forwardRef as se } from "react";
import { useI18n as re } from "next-localization";
import { a as ne, L as ue, c as oe } from "./LocationSearchForm.TYESw-kj.js";
import { INTERNAL_LINK_SELECTOR_MODULES as ce, INTERNAL_LINK_SELECTOR_NOT_MODULES as le } from "../constants/modules/index.js";
import { a as me, u as ie } from "./header.context.gmG2mr37.js";
import { u as he } from "./use-formatted-date.6zMpaWWb.js";
import { NeuGrid as u, NeuAlertContextual as ge, NeuFeedback as Se, NeuPagination as Le } from "@hcahealthcaredpx/neutron-react";
import { RichText as de } from "@sitecore-jss/sitecore-jss-nextjs";
import { C as fe } from "./CounterWithSorting.B6WiqexU.js";
import { D as Ne } from "./divider.C0gR8ZZB.js";
import { E as Re } from "./error-or-no-results.BD64KpRx.js";
import { SiteSearchContentType as ve } from "../types/search/index.js";
import { L as ye } from "./location-list-item.D5MZ5uY_.js";
import { u as Te } from "./use-location-search.Bk1SAmY4.js";
const K = se(
  ({ locations: s, accordionStartsOpen: h }, g) => /* @__PURE__ */ a("div", { ref: g, className: "d-flex flex-column gap-1", children: s.map((c) => /* @__PURE__ */ a(i.Fragment, { children: /* @__PURE__ */ a(
    ye,
    {
      item: {
        itemId: c.itemId ?? "",
        type: ve.location,
        ...c
      },
      isOpen: h,
      addTaggedWrapper: !1
    }
  ) }, c.facilityId)) })
);
K.displayName = "LocationSearchListing";
const $e = ({
  fields: s,
  facilityTypeOptions: h,
  specialtyOptions: g,
  persistentFilters: c,
  cardButtonOrder: W,
  modalDescription: e,
  parentFacilityId: $,
  accordionStartsOpen: j,
  hasTimestampAppended: q
}) => {
  var A, I, F, O, b, M;
  const { t: l } = re(), {
    FacilityNameSearch: H,
    LocationSearch: U,
    FacilityTypeSelect: p,
    Divider: z,
    SpecialtySelect: x,
    RadiusSelect: B,
    SubmitButton: _
  } = ne, [N, G] = i.useState([]), [V, R] = i.useState(void 0), [Z, k] = i.useState(!1), J = i.useRef(null), v = !N || N.length === 0 || Z, { pubDate: y } = me(
    (A = s == null ? void 0 : s.site.header) == null ? void 0 : A.erWaitTimeEndpoints
  ), { isModule: Q } = ie(), { timeStampWithDate: T } = he(
    y == null ? void 0 : y.replace("AKDT", "-0800").replace("AKST", "-0900")
  );
  let m = e;
  e != null && e.value && q && !(e != null && e.value.includes("{timestamp}")) && !(e != null && e.value.includes("{timestamp} on {date}")) && (m = {
    value: e.value + ` <span>${T}</span>`
  }), e != null && e.value && (e != null && e.value.includes("{timestamp}")) && !(e != null && e.value.includes("{timestamp} on {date}")) && (m = {
    value: e.value.replace("{timestamp}", `<span>${T}</span>`)
  }), e != null && e.value && (e != null && e.value.includes("{timestamp} on {date}")) && (m = {
    value: e.value.replace(
      "{timestamp} on {date}",
      `<span>${T}</span>`
    )
  });
  const {
    data: t,
    error: w,
    setLocationSearchParameter: L,
    locationSearchParameter: n,
    isValidating: E
  } = Te({
    filters: {
      ...c
    },
    page: 1,
    sort: "",
    radius: (I = s == null ? void 0 : s.defaultRequest) == null ? void 0 : I.radius,
    marketedSecondaryTypes: (F = s == null ? void 0 : s.defaultRequest) == null ? void 0 : F.marketedSecondaryTypes,
    parentFacilityId: $
  }), { count: X, start: Y, end: P } = i.useMemo(() => {
    const { page: r, total: o } = (t == null ? void 0 : t.data) ?? { total: 0, page: { start: 0, end: 0 } };
    return {
      count: o,
      start: (r == null ? void 0 : r.start) || 0,
      end: (r == null ? void 0 : r.end) || 0
    };
  }, [t == null ? void 0 : t.data]);
  i.useEffect(() => {
    var r;
    (r = t == null ? void 0 : t.data) != null && r.results && G(t.data.results), t != null && t.hasErrors && R(t.errors), w && R([
      {
        key: "LOCATION_SEARCH_FAILED",
        message: l("Search.Errors.LocationSearchFailed")
      }
    ]);
  }, [t, w, l]);
  const D = (r) => {
    const { facilityNameSearch: o, ...d } = r;
    if (R(void 0), k(!1), o)
      L(
        (S) => {
          var f;
          return S.locationName !== o ? {
            page: 1,
            sort: "",
            locationName: o,
            marketedSecondaryTypes: (f = s == null ? void 0 : s.defaultRequest) == null ? void 0 : f.marketedSecondaryTypes,
            filters: c
          } : S;
        }
      );
    else if (d.latitude && d.longitude || d.facilityTypeSelect) {
      const { facilityTypeSelect: S, ...f } = d, te = S ? {
        marketed_secondary_types_names: [S],
        ...c
      } : c, ae = oe(f);
      L({ ...ae, filters: te, page: 1, sort: "" });
    } else
      k(!0);
  }, ee = (r) => {
    L((o) => ({
      ...o,
      page: r.value
    }));
  };
  return /* @__PURE__ */ C(u, { fluid: !0, className: "max-h-lg-75vh overflow-hidden px-0 mx-0", children: [
    /* @__PURE__ */ a(u.Row, { gutter: "none", children: (m == null ? void 0 : m.value) && /* @__PURE__ */ a(ge, { kind: "info", className: "w-fit", children: /* @__PURE__ */ a(
      de,
      {
        internalLinksSelector: Q ? ce : le,
        field: m
      }
    ) }) }),
    /* @__PURE__ */ C(u.Row, { gutter: "none", className: "mt-3", children: [
      /* @__PURE__ */ a(u.Column, { col: 12, colLg: 4, className: "pe-lg-6", children: /* @__PURE__ */ a(
        ue,
        {
          locationSearchFormSubmit: D,
          config: {
            formFieldOrder: [
              H,
              z,
              U,
              ...h ? [p] : [],
              ...g ? [x] : [],
              B,
              _
            ],
            [_]: {
              buttonClassName: "w-100"
            },
            [p]: h ? {
              facilityOptions: h
            } : void 0,
            [x]: g ? {
              facilityOptions: g
            } : void 0
          }
        }
      ) }),
      /* @__PURE__ */ C(u.Column, { col: 12, colLg: 8, className: "h-100", children: [
        /* @__PURE__ */ a(u.Row, { gutter: "none", children: /* @__PURE__ */ a(u.Column, { col: 12, children: v ? null : /* @__PURE__ */ a(
          fe,
          {
            isLoading: E,
            contentTitleClassName: "d-flex align-items-end",
            count: X,
            start: Y,
            end: P,
            sort: (n == null ? void 0 : n.sort) || "",
            onSortChange: (r) => {
              L((o) => ({
                ...o,
                page: 1,
                sort: r
              }));
            },
            sortOptions: [
              { value: "", label: l("Search.Distance") },
              {
                value: "marketedfacilityname_s:asc",
                label: l("Locations.Search.Form.Sort.AZ")
              }
            ],
            resultDisplayName: "Results",
            className: "neu-text-caption",
            hideTitle: !0
          }
        ) }) }),
        /* @__PURE__ */ a(u.Row, { gutter: "none", children: /* @__PURE__ */ a(Ne, {}) }),
        /* @__PURE__ */ a(u.Row, { className: "h-320-lg overflow-y-lg-scroll", gutter: "none", children: E ? /* @__PURE__ */ a(Se, { kind: "spinner", size: "large", className: "h-100 align-items-center" }) : v ? /* @__PURE__ */ a(
          Re,
          {
            errors: V,
            noResultsTitle: n != null && n.radius ? l("Locations.Search.NoResultRadius", {
              radius: n == null ? void 0 : n.radius
            }) : l("Locations.Search.NoResults"),
            noResultsDescription: n != null && n.radius ? l("Locations.Search.TryAgainRadius") : l("Locations.Search.TryAgain")
          }
        ) : /* @__PURE__ */ a(
          K,
          {
            ref: J,
            fields: s,
            locations: N,
            cardButtonOrder: W,
            accordionStartsOpen: j
          }
        ) }),
        /* @__PURE__ */ a(u.Row, { gutter: "none", children: v || E ? null : /* @__PURE__ */ a("div", { className: "d-flex pt-3 justify-content-center", children: /* @__PURE__ */ a(
          Le,
          {
            color: "main",
            current: ((b = (O = t == null ? void 0 : t.data) == null ? void 0 : O.page) == null ? void 0 : b.current) || 1,
            kind: "paginator",
            limit: 10,
            onNeuChange: ee,
            results: ((M = t == null ? void 0 : t.data) == null ? void 0 : M.total) || 0
          }
        ) }) })
      ] })
    ] })
  ] });
};
export {
  K as L,
  $e as a
};
